import React from "react";

import Form from "@Components/Form";
import { GLOBAL_CONFIGURATION_URL } from "configs/constants";
import { useState } from "react";
import eightAxios from "configs/axiosConfig";
import { useEffect } from "react";
import LoadingIcon from "components/LoadingIcon/LoadingIcon";


const detailURL = "/configuration/get-config/";



const BannerCountConfig = () => {
    const [loading, setLoading] = useState(false);
    const [bannerDisplayCount, setBannerDisplayCount] = useState(0);
    const fetchDetails = () => {
   
        setLoading(true);
        eightAxios
          .get(detailURL)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.banner_display_count) {
                setBannerDisplayCount(response.data.banner_display_count);
              }
            }
            setLoading(false);
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response);
            }
            setLoading(false);
          });
      };
      const initialValues = { banner_display_count: bannerDisplayCount };
    
      useEffect(() => {
        fetchDetails();
      }, [bannerDisplayCount]);

  const formFields = [
   

    {
      type: "input",
      variant: "outlined",
      name: "banner_display_count",
      required: true,
      messageboxrequired: true,
      label: "Banner Display Count ",
      supportedTypes:["Only allow round number format and maximum number of banner display in each page is 20"],
      gridSize: { xs: 12, sm: 8, md: 3, lg: 3 },

       
    },
  ];

  const formButtons = ["submit"];
  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={GLOBAL_CONFIGURATION_URL}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Banner Count Configuration"
      
    />
  );
};

export default BannerCountConfig;
